import React from 'react'
import {Box, Divider, IconButton, Modal, Stack, Typography} from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"
import Playground from "./Playground"
import {AnyCustomModelJson} from "../../../api/json/CustomModelJson"

interface PlaygroundModalProps {
    open: boolean
    onClose: () => void
    model: AnyCustomModelJson
}

function PlaygroundModal({open, onClose, model}: PlaygroundModalProps) {
    return (
        <Modal open={open} onClose={onClose}>
            <Box sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: '95vw',
                maxWidth: 1200,
                maxHeight: '92vh',
                backgroundColor: '#f7f7f7',
                borderRadius: '6px',
                outline: 0,
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
            }}>
                <Stack direction="row"
                       alignItems="center"
                       justifyContent="space-between"
                       sx={{p: 2, backgroundColor: '#fff'}}>
                    <Stack direction="row" spacing={1.5} alignItems="baseline">
                        <Typography variant="h3" fontSize={18} fontWeight={500} sx={{color: '#555'}}>
                            Playground
                        </Typography>
                        <Typography variant="body2" sx={{color: '#888'}}>
                            {model.name}
                        </Typography>
                    </Stack>
                    <IconButton onClick={onClose} size="small">
                        <CloseIcon/>
                    </IconButton>
                </Stack>
                <Divider/>
                <Box sx={{p: 3, overflowY: 'auto', flex: '1 1 auto'}}>
                    <Playground model={model}/>
                </Box>
            </Box>
        </Modal>
    )
}

export default PlaygroundModal
